import React, { useState } from "react";
import NewSidebar from "./NewSidebar";
import DatabaseSidebar from "./DatabaseSidebar";

export default function SmartSidebar(props) {
  const [useLegacySidebar, setUseLegacySidebar] = useState(false);
  const hasManagedLoading = Boolean(props.onMenuReady && props.onMenuError);

  if (!hasManagedLoading && useLegacySidebar) {
    return <NewSidebar {...props} />;
  }

  return (
    <DatabaseSidebar
      {...props}
      onFatalError={(error) => {
        if (hasManagedLoading) props.onMenuError(error);
        else setUseLegacySidebar(true);
      }}
    />
  );
}
